module.exports = __webpack_public_path__ + "img/yunying@2x.e9842dc5.png";